import config from '../config';

const DEFAULT_BG =
    'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=1920&q=80';

/**
 * Resolve Portal/Dashboard V2 seasonal background URL.
 * - Absolute http(s) URLs are used as-is
 * - Relative paths are joined with SERVER_URL_IMG
 * - Optional PORTAL_V2_BG_VERSION busts cache when the same filename is replaced
 */
export function getPortalV2BackgroundUrl() {
    const raw =
        (config.PORTAL_V2_BG_IMAGE && String(config.PORTAL_V2_BG_IMAGE).trim()) ||
        DEFAULT_BG;
    let url = raw;
    if (!/^https?:\/\//i.test(raw)) {
        const base = String(config.SERVER_URL_IMG || '').replace(/\/?$/, '/');
        url = `${base}${raw.replace(/^\//, '')}`;
    }
    const version = config.PORTAL_V2_BG_VERSION;
    if (version != null && String(version).trim() !== '') {
        const sep = url.includes('?') ? '&' : '?';
        url = `${url}${sep}v=${encodeURIComponent(String(version).trim())}`;
    }
    return url;
}

function setPortalV2Background(url) {
    const root = document.documentElement;
    if (!url) {
        root.style.removeProperty('--portal-v2-bg-image');
        return;
    }
    root.style.setProperty('--portal-v2-bg-image', `url("${url}")`);
}

/**
 * Apply shared CSS var used by .dv2 and .pv2 backgrounds.
 * If the configured file is missing (prod serves the SPA HTML for that URL),
 * leave the variable unset so the stylesheet Unsplash fallback paints.
 */
export function applyPortalV2Background() {
    if (typeof document === 'undefined') return;
    const url = getPortalV2BackgroundUrl();
    if (typeof Image === 'undefined') {
        setPortalV2Background(url);
        return;
    }
    const img = new Image();
    img.onload = () => {
        if (!img.naturalWidth) {
            setPortalV2Background('');
            return;
        }
        setPortalV2Background(url);
    };
    img.onerror = () => setPortalV2Background('');
    img.src = url;
}

export default applyPortalV2Background;
